<template>
  <div class="ui form">
    <h4 class="ui dividing header">{{ $t("date range") }}</h4>
    <div class="two fields">
      <div class="field">
        <label>{{ $t("start date") }}</label>
        <div class="ui calendar" ref="range_start">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('start date')" />
          </div>
        </div>
      </div>
      <div class="field">
        <label>{{ $t("end date") }}</label>
        <div class="ui calendar" ref="range_end">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" :placeholder="$t('end date')" />
          </div>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header" v-if="attributes && attributes.length > 0">
      {{ $t("attributes") }}
    </h4>
    <div class="field" v-for="(attribute, index) in attributes" :key="index">
      <label for="">{{ attribute.name }}</label>
      <input type="text" name="" v-model="attributes[index].value" />
    </div>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import { cloneDeep } from "lodash";

export default {
  name: "CourseAssignationModalGeneral",
  props: {
    season_in: Object,
    configuration: Object,
  },
  components: {},
  data() {
    return {
      attributes: [],
      start_date: "",
      end_date: "",
    };
  },
  methods: {
    getList() {
      return this.attributes;
    },
    getData() {
      return {
        attributes: this.attributes,
        start_date: this.start_date,
        end_date: this.end_date,
      };
    },
    update() {
      let vm = this;
      if (
        vm.configuration &&
        vm.configuration.conf &&
        vm.configuration.conf.setup &&
        vm.configuration.conf.setup.attributes
      ) {
        vm.attributes = vm.configuration.conf.setup.attributes;
      }

      if (vm.season_in && vm.season_in.uuid) {
        if (vm.attributes) {
          vm.attributes.map((att) => {
            let trgt = vm.season_in.setup.general.find((at) => {
              return at.id == att.id;
            });
            if (trgt) att.value = trgt.value;
          });
        } else {
          vm.attributes = cloneDeep(vm.season_in.setup.general);
        }
      }

      window.jQuery(vm.$refs.range_start).calendar({
        today: true,
        type: "date",
        endCalendar: window.jQuery(vm.$refs.range_end),
        onSelect(value) {
          vm.start_date = value;
        },
      });
      window.jQuery(vm.$refs.range_end).calendar({
        today: true,
        type: "date",
        startCalendar: window.jQuery(vm.$refs.range_start),
        onSelect(value) {
          vm.end_date = value;
        },
      });
    },
  },
  // created() {
  //   let vm = this;
  //   local_api(this, "post", "/course/setting/do-get-configuration")
  //     .then((conf) => {
  //       if (conf && conf.setup && conf.setup.attributes) {
  //         vm.attributes = conf.setup.attributes;
  //       }
  //     })
  //     .catch((err) => {
  //       error_toast(err);
  //     });
  // },
  mounted() {},
  watch: {},
};
</script>
